import { render, staticRenderFns } from "./registerAccount.vue?vue&type=template&id=420ed02a&scoped=true&"
import script from "./registerAccount.vue?vue&type=script&lang=js&"
export * from "./registerAccount.vue?vue&type=script&lang=js&"
import style0 from "./registerAccount.vue?vue&type=style&index=0&id=420ed02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ed02a",
  null
  
)

export default component.exports